import type { ConfigResult, OrderPilotSettings, WidgetConfig } from '../types';

export function resolveConfig(
    scriptWidgetKey: string | undefined,
    scriptApiUrl: string | undefined,
    scriptSrc: string | undefined,
    settings: OrderPilotSettings | undefined,
): ConfigResult {
    const candidate = settings?.widgetKey ?? scriptWidgetKey;

    if (typeof candidate !== 'string' || candidate.trim().length === 0) {
        return {
            ok: false,
            reason: 'Missing widgetKey. Add data-widget-key to the snippet or set window.orderPilotSettings.',
        };
    }

    return {
        ok: true,
        config: {
            widgetKey: candidate.trim(),
            apiOrigin: resolveApiOrigin(
                settings?.apiUrl ?? scriptApiUrl,
                scriptSrc,
            ),
        },
    };
}

export function widgetConfigUrl(config: WidgetConfig): string {
    return `${config.apiOrigin}/api/widget/${config.widgetKey}/config`;
}

function resolveApiOrigin(
    override: string | undefined,
    scriptSrc: string | undefined,
): string {
    const trimmed = override?.trim();

    if (trimmed) {
        return trimmed.replace(/\/+$/, '');
    }

    if (scriptSrc) {
        try {
            return new URL(scriptSrc, window.location.href).origin;
        } catch {
            // fall through to location origin
        }
    }

    return window.location.origin;
}
